import {
  CarriedInterestFeeAllocationMethod,
  OutsideCommitmentCapitalTreatment,
  WaterfallStructure,
} from 'further-types/lp/carry-settings';
import { carrySettings } from 'further-ui/validations';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';
import { z } from 'zod';

export type FormValues = z.infer<
  typeof carrySettings.OverallCarriedInterestSettings
>;

const feeAllocationMethodOptions = [
  {
    label: 'Commitment pro-rata',
    value: CarriedInterestFeeAllocationMethod.CommitmentProRata,
  },
  {
    label: 'Investor-specific',
    value: CarriedInterestFeeAllocationMethod.InvestorSpecific,
  },
];

const outsideCommitmentCapitalTreatmentOptions = [
  {
    label: 'Included in preferred return calculations',
    value:
      OutsideCommitmentCapitalTreatment.IncludedInPreferredReturnCalculations,
  },
  {
    label: 'Excluded from preferred return calculations',
    value:
      OutsideCommitmentCapitalTreatment.ExcludedFromPreferredReturnCalculations,
  },
];

const defaultWaterfallStructure = [
  WaterfallStructure.ReturnOfCapital,
  WaterfallStructure.PreferredReturn,
  WaterfallStructure.CarriedInterestPartnerCatchup,
  WaterfallStructure.ExcessProceeds,
];

type Callbacks = {
  onMutate?: () => void;
  onSettled?: () => void;
};

export default function useOverallCarriedInterestSettings(
  callbacks?: Callbacks,
) {
  const options = useHandleTrpcMutation()({
    successMessage: 'Overall carried interest settings updated.',
    onMutate: () => callbacks?.onMutate?.(),
    onSettled: () => callbacks?.onSettled?.(),
  });

  const { mutate: updateSettings, isPending } =
    api.vehicle.updateOverallCarriedInterestSettings.useMutation(options);

  return {
    feeAllocationMethodOptions,
    outsideCommitmentCapitalTreatmentOptions,
    defaultWaterfallStructure,
    updateSettings,
    isPending,
  };
}
